import React from 'react';
import Select from 'react-select';
import { brandSelectTheme } from './reactSelectTheme';

/**
 * TplSelect — the application's standard themed dropdown.
 *
 * A thin wrapper over react-select that applies the LedgerLoop brand
 * theme (brandSelectTheme) and a control style matching the rest of
 * the form inputs. Use this in place of a native <select> so every
 * dropdown looks and behaves consistently.
 *
 * Options are plain { value, label } objects; the `value` prop and the
 * `onChange` argument are the bare value (not the option object), so
 * it is a drop-in replacement for a controlled native <select>.
 *
 * Props:
 *   options      Array<{ value, label }>
 *   value        the currently selected value (bare)
 *   onChange     (value) => void   — '' when cleared
 *   placeholder  string
 *   isDisabled   bool
 *   isClearable  bool
 */
export const tplSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: '40px',
        borderWidth: '1.5px',
        borderColor: state.isFocused ? 'var(--primary, #44814E)' : '#e5e7eb',
        borderRadius: '8px',
        boxShadow: state.isFocused ? '0 0 0 3px var(--rgba-primary-2, rgba(68,129,78,0.2))' : 'none',
        fontSize: '0.875rem',
        '&:hover': { borderColor: 'var(--primary, #44814E)' },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, fontSize: '0.875rem' }),
};

function TplSelect({ options, value, onChange, placeholder, isDisabled, isClearable = false }) {
    const selected = options.find((o) => o.value === value) || null;
    return (
        <Select
            classNamePrefix="tpl-rs"
            options={options}
            value={selected}
            onChange={(opt) => onChange(opt ? opt.value : '')}
            theme={brandSelectTheme}
            styles={tplSelectStyles}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            placeholder={placeholder || 'Välj…'}
            isDisabled={isDisabled}
            isClearable={isClearable}
            noOptionsMessage={() => 'Inga alternativ'}
        />
    );
}

export default TplSelect;
